export enum MinimumPalletLoadPercents {
  PER_25 = 25,
  PER_50 = 50,
  PER_75 = 75,
  PER_100 = 85,
}
